import {
  SET_ACTIVE_SIDEBAR_ARTICLES,
  SET_ACTIVE_SIDEBAR_SECTION,
  SET_ACTIVE_LIST_ARTICLES,
  SET_LISTS_TASKS,
  TOGGLE_SIDEBAR_COLLAPSED,
} from './actions';


const initialState = {
  activeSection: 'Overview',
  activeSectionArticles: localStorage.getItem('activeSidebarArticles') || 'Articles',
  activeList: null,
  lists: [],
  collapsed: false,
};

export default function sidebarReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_SIDEBAR_SECTION:
      return {
        ...state,
        activeSection: action.section,
      };
    case SET_ACTIVE_SIDEBAR_ARTICLES:
      return {
        ...state,
        activeSectionArticles: action.section,
      };
    case SET_ACTIVE_LIST_ARTICLES:
      return {
        ...state,
        activeList: action.list,
      };
    case SET_LISTS_TASKS:
      return {
        ...state,
        lists: action.lists,
      };
    case TOGGLE_SIDEBAR_COLLAPSED:
      return {
        ...state,
        collapsed: !state.collapsed,
      };
    default:
      return state;
  }
}
